module.exports = __webpack_public_path__ + "static/media/undraw_programming_animated.cf135307.svg";